import styled from "styled-components";

import materialUI from "../../material-UI";
import Colors from "../../constants/color";

export const Container = styled.div<{ hidden?: boolean }>`
  height: 100%;
  width: 100%;
  display: ${(props) => (props.hidden ? "none" : "block")};
`;

interface SidebarProps {
  isExpanded: boolean;
}

interface Props {
  url: string;
  isExpanded?: boolean;
}

export const SidebarWrapper = styled.div<SidebarProps>`
  position: fixed;
  left: -8px;
  top: 16px;
  height: calc(100vh - 16px);
  width: ${(props) => `calc(${props.isExpanded ? "320px" : "80px"} + 8px)`};
  z-index: 1200;
  transition: width 0.3s ease;
  overflow: hidden;
`;

export const SidebarContainer = styled.div<SidebarProps>`
  position: relative;
  left: 8px;
  top: 0;
  height: 100%;
  width: ${(props) => (props.isExpanded ? "320px" : "80px")};
  background-color: #2d5bff;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 0;
  padding-top: 16px;

  /* Atualiza variável CSS global para o layout */
  --sidebar-width: ${(props) => (props.isExpanded ? "320px" : "80px")};
`;

export const SidebarContainerStyled = styled.div<SidebarProps>`
  position: relative;
  left: 8px;
  top: 0;
  height: 100%;
  width: ${(props) => (props.isExpanded ? "320px" : "80px")};
  background-color: #2d5bff;
  transition: width 0.3s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 0;
  padding-top: 16px;

  /* Atualiza variável CSS global para o layout */
  --sidebar-width: ${(props) => (props.isExpanded ? "320px" : "80px")};
`;

export const NavStyled = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-color: #2d5bff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-bottom: 2px;
  position: relative;
  flex: 1;
  overflow: hidden;
`;

export const ListStyled = styled.div`
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow: hidden;
`;

export const GroupItemsStyled = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 16px;
  z-index: 1;
  align-items: ${(props) => (props.isExpanded ? "stretch" : "center")};
  gap: 4px;

  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`;

export const SidebarShadow = styled.div<SidebarProps>`
  position: absolute;
  right: -20px;
  top: 0;
  width: ${(props) => (props.isExpanded ? "20px" : "0px")};
  height: 100vh;
  background: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.3) 0%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
  transition: width 0.3s ease;
  z-index: 1199;
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
`;

export const UserInfo = styled.div<Props>`
  width: 100%;
  background-color: #2d5bff;
  border-top-right-radius: 0;
  height: auto;
  min-height: 0;
  display: none;
  transition: all 0.3s ease;
`;

export const SellitLogo = styled.div<SidebarProps>`
  margin: 8px;
  padding: 6px ${(props) => (props.isExpanded ? "36px" : "8px")};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(51, 51, 51, 0.2);
  border-radius: 24px;
  transition: padding 0.3s ease, border-radius 0.3s ease;
  opacity: 1;
  overflow: hidden;
  height: 56px;
  min-height: 56px;
  max-height: 56px;
  width: ${(props) => (props.isExpanded ? "auto" : "56px")};
  min-width: 56px;

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
  }

  img.logo-full {
    width: 120px;
    height: 44px;
    object-fit: contain;
    transition: all 0.3s ease;
  }

  img.logo-small {
    width: 40px;
    height: 40px;
    object-fit: contain;
    transition: all 0.3s ease;
  }
`;

export const HeaderSection = styled.div<SidebarProps & { isProd?: boolean }>`
  padding: 0 8px 12px;
  background-color: #2d5bff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${(props) => (props.isProd ? "center" : "flex-start")};
  gap: 6px;
  transition: padding 0.3s ease;
  margin-bottom: 8px;
  height: ${(props) => (props.isProd ? "88px" : "140px")};
  min-height: ${(props) => (props.isProd ? "88px" : "140px")};
  max-height: ${(props) => (props.isProd ? "88px" : "140px")};
  overflow: hidden;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 16px;
    right: 16px;
    height: 2px;
    background-color: #ffffff;
  }
`;

export const HrContainer = styled.div<SidebarProps>`
  width: 100%;
  display: flex;
  justify-content: center;
  padding: ${(props) => (props.isExpanded ? "0 16px 8px" : "0")};
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
  height: ${(props) => (props.isExpanded ? "auto" : "0")};
  overflow: hidden;
  transition: all 0.3s ease;

  hr {
    background-color: rgba(255, 255, 255, 0.2);
    width: 100%;
    height: 1px;
    border: none;
    border-radius: 50%;
    margin: 0;
  }
`;

export const AmbienteInfo = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  align-items: center;
  height: 50px;
  min-height: 50px;
  justify-content: center;
`;

export const AmbienteBadge = styled.div<SidebarProps>`
  background-color: #ff9800;
  color: #ffffff;
  padding: 4px 6px;
  border-radius: 4px;
  font-size: ${(props) => (props.isExpanded ? "10px" : "9px")};
  font-weight: 600;
  text-align: center;
  font-family: Inter;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 20px;
  min-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const CargoBadge = styled.div<SidebarProps>`
  background-color: #4caf50;
  color: #ffffff;
  padding: 3px 5px;
  border-radius: 4px;
  font-size: ${(props) => (props.isExpanded ? "9px" : "8px")};
  font-weight: 500;
  text-align: center;
  font-family: Inter;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 18px;
  min-height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const AvatarBox = styled.div<SidebarProps>`
  width: ${(props) => (props.isExpanded ? "45px" : "40px")};
  height: ${(props) => (props.isExpanded ? "45px" : "40px")};
  border-radius: 100%;
  background: #ececec;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
`;
export const ImgAvatar = styled.img`
  width: 100%;
  border-radius: 100%;
`;
export const UserData = styled.div<SidebarProps>`
  display: block;
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
  width: ${(props) => (props.isExpanded ? "auto" : "0")};
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s ease;
`;
export const UserName = styled.h2<SidebarProps>`
  font-family: Inter;
  font-weight: 400;
  font-size: 12px;
  line-height: 19px;
  color: #ffffff;
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
  width: ${(props) => (props.isExpanded ? "auto" : "0")};
  overflow: hidden;
  white-space: nowrap;
  transition: all 0.3s ease;
`;
export const UserLink = styled.a`
  font-family: Inter;
  font-weight: 400;
  font-size: 16px;
  line-height: 12px;
  margin-bottom: 11px;
  color: #ffffff;
  text-decoration: none;
`;
export const Img = styled.img`
  height: 16px;
`;
export const List = styled.div`
  padding-top: 8px;
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow: hidden;
`;
export const GroupItems = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 16px;
  z-index: 1;
  align-items: ${(props) => (props.isExpanded ? "stretch" : "center")};
  gap: 4px;

  /* Customização da scrollbar */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }

  /* Escopo específico para MuiPaper dentro da sidebar (seguindo padrão antigo) */
  .MuiPaper-root {
    background-color: #2d5bff;
  }
`;
export const Nav = styled.div<SidebarProps>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  background-color: #2d5bff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  padding-bottom: 2px;
  position: relative;
  flex: 1;
  overflow: hidden;
`;
export const Collapse = styled(materialUI.Collapse)``;

export const AccordionStyled = styled(materialUI.Accordion)<SidebarProps>`
  box-shadow: none;
  background-color: transparent !important;
  margin: 0 !important;
  width: 100%;

  .MuiAccordionSummary-expandIconWrapper {
    display: none !important;
  }

  .MuiAccordionSummary-expandIconWrapper.Mui-expanded {
    transform: rotate(90deg);
  }

  .MuiPaper-root {
    background-color: #2d5bff !important;
  }

  .MuiAccordionSummary-root {
    padding: ${(props) => (props.isExpanded ? "0 16px" : "0")} !important;
    margin: 0 !important;
    min-height: 48px !important;
    justify-content: ${(props) =>
      props.isExpanded ? "space-between" : "center"} !important;
    align-items: center !important;
  }

  .MuiAccordionSummary-content {
    margin: 0 !important;
    display: flex;
    align-items: center;
    justify-content: ${(props) =>
      props.isExpanded ? "flex-start" : "center"} !important;
    width: ${(props) => (props.isExpanded ? "auto" : "100%")} !important;
    flex-grow: ${(props) => (props.isExpanded ? "1" : "0")} !important;
  }

  .MuiAccordionDetails-root {
    padding: ${(props) => (props.isExpanded ? "8px 16px 16px 16px" : "0")};
    opacity: ${(props) => (props.isExpanded ? "1" : "0")};
    height: ${(props) => (props.isExpanded ? "auto" : "0")};
    overflow: hidden;
    transition: all 0.3s ease;
  }
`;

export const FlexContainer = styled.div<SidebarProps>`
  display: flex;
  border: none;
  box-shadow: none;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  margin: 0;
  color: #ffffff;
  font-family: Inter;
  gap: ${(props) => (props.isExpanded ? "16px" : "0")};
  justify-content: ${(props) => (props.isExpanded ? "flex-start" : "center")};
  align-items: center;
  transition: all 0.3s ease;
  width: 100%;

  svg {
    width: ${(props) => (props.isExpanded ? "16px" : "24px")};
    height: ${(props) => (props.isExpanded ? "16px" : "24px")};
    flex-shrink: 0;
  }

  p {
    opacity: ${(props) => (props.isExpanded ? "1" : "0")};
    width: ${(props) => (props.isExpanded ? "auto" : "0")};
    overflow: hidden;
    white-space: nowrap;
    transition: all 0.3s ease;
    margin: 0;
  }
`;

export const ButtonArrow = styled.button`
  border-radius: 4px;
  cursor: pointer;
  background-color: transparent;

  .rotate {
    transform: rotate(-90deg);
    transition: 0.5s;
  }
  .not-rotate {
    transform: rotate(0deg);
    transition: 0.5s;
  }
`;

export const LinkList = styled.ul<SidebarProps>`
  width: 100%;
  align-items: left;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
  border: none;
  box-shadow: none;
  opacity: ${(props) => (props.isExpanded ? "1" : "0")};
  height: ${(props) => (props.isExpanded ? "auto" : "0")};
  overflow: hidden;
  transition: all 0.3s ease;
  li {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  a {
    text-decoration: none;
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    padding-left: ${(props) => (props.isExpanded ? "0" : "0")};
    color: #ffffff;
    font-family: Inter;
    display: block;
  }
`;

export const FooterLogoutSection = styled.div<SidebarProps>`
  background-color: #466fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: sticky;
  bottom: 0;
  z-index: 20;
  border-bottom-right-radius: 0;
  position: relative;

  > div:first-child {
    padding: ${(props) => (props.isExpanded ? "20px" : "10px")};
    justify-content: ${(props) => (props.isExpanded ? "flex-start" : "center")};
    transition: all 0.3s ease;
    position: relative;

    &::after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 16px;
      right: 16px;
      height: 2px;
      background-color: #ffffff;
    }
  }
`;

export const UserAvatar = styled.div<SidebarProps>`
  width: ${(props) => (props.isExpanded ? "45px" : "40px")};
  height: ${(props) => (props.isExpanded ? "45px" : "40px")};
  border-radius: 100%;
  flex-shrink: 0;
  transition: all 0.3s ease;
`;
